import React, {useState, useEffect} from 'react';

import { Section,SectionTitle,SectionTitle2,SliderCard1,SectionDesc } from "../components/reuseable"
import { PopupPhoto } from "../components/reuseable/popup"
import Carousel from "../components/reuseable/carousel"

import { useAuth } from "../app/context";


const PersonalInfo = () =>{

  let { isLoaded, personal,translations,photos,handleUpdatePhoto } = useAuth();

  const [showPopup, setShowPopup] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(2);


// Photo gallery functions - Fixed
  const openModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setPhotoIndex(1);
    setShowPopup(true);
  };

  const closeModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setPhotoIndex(1);
    setShowPopup(false);
  };
  
  const nextPhoto = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }    
    setPhotoIndex((prevIndex) => prevIndex < photos.length - 1?prevIndex + 1: 1);

  };

  const prevPhoto = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setPhotoIndex((prevIndex) => prevIndex > 1?prevIndex - 1:photos.length - 1);
  };

  useEffect(() => {
    handleUpdatePhoto(photoIndex);
  }, [photoIndex]);

  
  const _personal = translations.personal;
  

  return(
    <Section id="personal">
      <SectionTitle title={_personal.title} ts="1"/>

      {!!isLoaded && <div className="block-full my-40 sm:my-48 text-left">
        <Carousel
          dragable= {true}
          dots= {true}
          autoplay= {true}
          autoplayHoverPause= {true}
          autoplayTimeout= {4000}
          smartSpeed= {500}
          responsive= {{
            0 : {items: 1,margin:24},
            768 : {items: 2,margin:24},
            992 : {items: 3,margin:32},
          }}
        >
          <SliderCard1 className="gradient-bc-1">
            <h4 className="flex-row-full font-inter fw-600 fs-20 lh-24 color-header-2 mb-16">
              {personal.emoji}
              <span className="color-highlight mx-8">●</span>
              {_personal.tabs[0][0]}
            </h4>
            <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-20">
              <div className="fw-600 color-strong">{_personal.tabs[0][1]}:</div>
              <div className="color-normal">{personal.dateOfBirth}</div>
            </div>
            <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none mb-20">
              <div className="fw-600 color-strong">{_personal.tabs[0][2]}:</div>
              <div className="color-normal">{personal.placeOfBirth}</div>
            </div>
            <div className="flex-row-full gap-8 font-inter fw-400 fs-16 lh-none">
              <div className="fw-600 color-strong">{_personal.tabs[0][3]}:</div>
              <div className="color-normal">{personal.height}</div>
            </div>
          </SliderCard1>

        {personal.items.map((item,index)=>{
            return <SliderCard1 className="gradient-bc-1c" key={index}>
            <h4 className="flex-row-full font-inter fw-600 fs-20 lh-24 color-header-2 mb-16">
              {item.emoji}
              <span className="color-highlight mx-8">●</span>
              {item.title}
            </h4>
            <div className="block-full font-inter fw-400 fs-16 lh-24 color-normal">{item.description}</div>
          </SliderCard1>
          })}
        </Carousel>
      </div>}

      {!!isLoaded && <SectionTitle2 title={_personal.title2} ts={1}/>}
      {!!isLoaded && <SectionDesc value={_personal.description}/>}


      {!!isLoaded && <button 
        id="photo-btn"
        className="flex-row-auto items-center bg-white color-accent mx-auto gap-8 br-12 py-16 sm:py-24 px-32 sm:px-48 mt-32 fw-600 font-inter fs-16 lh-none stroke-accent shadow-sm hover:shadow-md transition-fast lift-4"
        onClick={openModal}
      >
      <svg className="w-24 h-24" viewBox="0 0 24 24"  fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth="2"><circle cx="16" cy="8" r="2"/><path d="m2 12.5 1.752-1.533a2.3 2.3 0 0 1 3.14.105l4.29 4.29a2 2 0 0 0 2.564.222l.299-.21a3 3 0 0 1 3.731.225L21 18.5" strokeLinecap="round"/><path d="M22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12s0-7.071 1.464-8.536C4.93 2 7.286 2 12 2s7.071 0 8.535 1.464c.974.974 1.3 2.343 1.41 4.536" strokeLinecap="round"/></svg>
      {_personal.btns[0]} ({photos.length - 1 })
      </button>}

      {!!showPopup && !!isLoaded && <PopupPhoto onClose={closeModal}>
        {!!photos[photoIndex] && <div className="block-full br-12 shadow-lg">
          <img className="block-full br-12" src={photos[photoIndex]} alt="Gallery Photo"/>
        </div>}

        {!photos[photoIndex] && <div className="flex-row-full justify-center items-center br-12 shadow-lg" style={{"aspectRatio": "1/1"}}>
          <div className="block-f50 fill-header-2">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><circle cx="12" cy="3" r="1"><animate id="spinner_7Z73" begin="0;spinner_tKsu.end-0.5s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="16.50" cy="4.21" r="1"><animate id="spinner_Wd87" begin="spinner_7Z73.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="7.50" cy="4.21" r="1"><animate id="spinner_tKsu" begin="spinner_9Qlc.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="19.79" cy="7.50" r="1"><animate id="spinner_lMMO" begin="spinner_Wd87.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="4.21" cy="7.50" r="1"><animate id="spinner_9Qlc" begin="spinner_Khxv.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="21.00" cy="12.00" r="1"><animate id="spinner_5L9t" begin="spinner_lMMO.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="3.00" cy="12.00" r="1"><animate id="spinner_Khxv" begin="spinner_ld6P.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="19.79" cy="16.50" r="1"><animate id="spinner_BfTD" begin="spinner_5L9t.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="4.21" cy="16.50" r="1"><animate id="spinner_ld6P" begin="spinner_XyBs.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="16.50" cy="19.79" r="1"><animate id="spinner_7gAK" begin="spinner_BfTD.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="7.50" cy="19.79" r="1"><animate id="spinner_XyBs" begin="spinner_HiSl.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="12" cy="21" r="1"><animate id="spinner_HiSl" begin="spinner_7gAK.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><animateTransform attributeName="transform" type="rotate" dur="6s" values="360 12 12;0 12 12" repeatCount="indefinite"/></g></svg>
          </div>
        </div>}



        <div className="flex-row-full items-center justify-space-between mt-32 gap-8 sm:gap-16">
            <button 
              onClick={prevPhoto}
              className="bw-2 bs-solid bc-gray 
              br-8 px-8 py-8 gap-4 sm:br-12 sm:px-16 sm:py-12 sm:gap-8
              font-inter fs-16 fw-500 lh-20
              bg-white hover:bg-gray color-normal hover:color-accent
              flex-row-max items-center justify-center 
              cursor-pointer overflow-hidden transition-fast"
            >
                <span className="block-max fw-600 fs-20 lh-20">‹</span> {_personal.btns[1]}
            </button>

            <div className="block-max br-8 overflow-hidden">
              <div className="block-full h-full top- left-0 absolute bg-accent opacity-10">&nbsp;</div>
              <span className="block-max color-highlight-2 font-inter fs-16 lh-20 fw-500 px-12 py-12 sm:px-16 sm:py-16">{photoIndex} {_personal.btns[2]} {photos.length-1} </span>
            </div>

            <button 
              onClick={nextPhoto}
              className="bw-2 bs-solid bc-gray
              br-8 px-8 py-8 gap-4 sm:br-12 sm:px-16 sm:py-12 sm:gap-8
              font-inter fs-16 fw-500 lh-20
              bg-white hover:bg-gray color-normal hover:color-accent
              flex-row-max items-center justify-center 
              cursor-pointer overflow-hidden transition-fast"
            >
                {_personal.btns[3]} <span className="block-max fw-600 fs-20 lh-20">›</span>
            </button>
        </div>
      </PopupPhoto>}

    </Section>
  )
}

export default PersonalInfo;
